"use client";

import { c as _c } from "react/compiler-runtime";
import { Container, SectionSubHeading, SectionTitle } from "@/components";
import JobOpeningsList from "./JobOpeningsList";
import { ArrowBigRightDash } from "lucide-react";
import { motion, Variants } from "framer-motion";
const fadeInUp: Variants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: {
      duration: 1,
      delay: i * 0.2,
      ease: [0.76, 0, 0.24, 1]
    }
  })
};
const CareerOpenings = () => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      once: true
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <motion.div custom={0} initial="hidden" whileInView="visible" viewport={t0} variants={fadeInUp}><SectionTitle className="text-white" title="Current Openings" /></motion.div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      once: true
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="bg-accent-foreground md:py-16 py-10"><Container className="px-4 lg:px-10 flex flex-col lg:gap-16 gap-12"><div className="space-y-8">{t1}<div className="flex items-center gap-6 lg:ml-40 md:max-w-sm"><motion.div custom={1} initial="hidden" whileInView="visible" viewport={t2} variants={fadeInUp} className="flex items-center gap-6 md:max-w-sm"><ArrowBigRightDash className="text-6xl text-primary shrink-0" /><SectionSubHeading className="text-white" subtitle="If you think you might be a good fit for our team, we'd love to hear from you!" /></motion.div></div></div><JobOpeningsList /></Container></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
export default CareerOpenings;